import { useAppDispatch, useAppTranslation, useErrTranslation } from 'app/hooks';
import { showConfirmModal } from 'components/Modals/CommonModals';
import Typo from 'consts/typography';
import { useCallback } from 'react';
import CloseIcon from 'assets/icons/CloseIcon';
import useThemes from './useThemes';
import ErrorIcon from 'assets/icons/ErrorIcon';
import { setCashierMenuTab, setShowCashierMenu } from 'features/home/homeSlice';

const useHandleInsufficientBalance = () => {
  const dispatch = useAppDispatch();
  const et = useErrTranslation();
  const t = useAppTranslation();
  const { currentTheme } = useThemes();

  const handleDepositNow = () => {
    dispatch(setCashierMenuTab(4));
    dispatch(setShowCashierMenu(true));
  };

  return useCallback(
    () => {
      showConfirmModal({
        content: (
          <p className={`font-bold ${Typo.p2} mb-0`}>{et('error.validate.balance.insufficient')}</p>
        ),
        onOk: handleDepositNow,
        title: <p className={`font-bold ${Typo.p1}  mb-0`}>{et('defaultMessage.title')}</p>,
        okText: t('footerMenu.cashier.deposit'),
        closeIcon: <CloseIcon width="20" height="20" isDarkMode={currentTheme === 'dark'} />,
        closable: true,
        icon: <ErrorIcon width="50" height="50" />,
        cancelText: t('deposit.close'),
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, et, currentTheme],
  );
};

export { useHandleInsufficientBalance };
